const elementTypeIds = {
  TEXT: '3dcb87aa-8bb5-4482-bdfb-4e70ec6e9dda',
  VIDEO: 'a7b240df-6353-46ca-81a5-4057e9fb9f19',
  RICH_TEXT: '217f10ba-a9dd-488d-9841-7778556e7488',
  IMAGE: '995bbd9b-5168-47f3-855d-13b658b47760',
  TEXT_AREA: '3dcb87aa-8bb5-4482-bdfb-4e70ec6e9dda',
  SOCIAL_MEDIA: '925f2084-1c5c-44e1-9e0e-3be48e2b0bd8',
  MULTIPLE_CHOICE: '9ae5edc2-d7fb-47ea-8893-8b6acf55b717',
  SUBMISSION_TYPE_SELECTOR: 'b7c8d9e0-1234-5678-90ab-cdef12345678'
};

export const SUBMISSION_TYPE_SELECTOR_ELEMENT_TYPE_ID = 'b7c8d9e0-1234-5678-90ab-cdef12345678';

export const SUBMISSION_TYPES = {
  VIDEO: 'video',
  IMAGE: 'image',
  TEXT: 'text'
};

export const SUBMISSION_TYPE_LABELS = {
  video: 'Record/Upload Video',
  image: 'Upload Image',
  text: 'Write Text'
};

export const SocialMediaOptions = ['Amazon', 'Google', 'Facebook', 'Youtube', 'Twitter'];

export default elementTypeIds;



// WEBPACK FOOTER //
// ./src/constants/element-types.js